import Header from "@/components/Header";
import Footer from "@/components/Footer";

const TermsOfUsePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        {/* Banner */}
        <div className="bg-[#4A6670] py-16 sm:py-20">
          <div className="max-w-5xl mx-auto px-6 lg:px-12">
            <h1 className="text-3xl sm:text-4xl font-medium text-white font-heading" data-testid="terms-page-title">
              Terms of Use
            </h1>
            <div className="w-16 h-[2px] bg-[#E87722] mt-4" />
          </div>
        </div>

        {/* Content */}
        <div className="py-16 sm:py-20">
          <div className="max-w-5xl mx-auto px-6 lg:px-12 space-y-6">
            <p className="text-sm leading-relaxed text-slate-600 font-body">
              InCred Global Asset Management Pte Ltd. (IGAM) undertakes all measures to ensure the reliability of the information on this website. We have no liability for any loss resulting from the use of this website or its contents.
            </p>
            <p className="text-sm leading-relaxed text-slate-600 font-body">
              This material is provided for information purposes only and does not constitute a solicitation, invitation, or an offer or endorsement to use a service, to buy/sell investment instruments, nor to perform any other transaction, however, solely for marketing and information purposes. In addition, the information is not intended for distribution to or for use by individuals or legal entities that are citizens of a country or have their domicile or registered offices in a country where the distribution, publication, provision, or use of this information would violate applicable laws or regulations in a country in which IGAM would have to comply with registration or approval requirements. Readers who read this website should make themselves aware and adhere to any such restrictions. By reading this website you agree to be bound by the preceding limitations. It should also be noted that all investments carry a certain amount of risk and should not, therefore, be entered into without professional advice.
            </p>
            <p className="text-sm leading-relaxed text-slate-600 font-body">
              Nothing on this site constitutes investment, legal, accounting, or tax advice, or a representation that any investment or strategy is suitable or appropriate for individual circumstances, or otherwise constitutes a personal recommendation for any specific investor. We recommend that investors independently assess, with a professional advisor, the specific financial risks as well as legal, regulatory, credit, accounting, and tax consequences. The content on the website may be updated, revised, deleted, or modified without notice. Information should only be considered updated as of the time of publication or as otherwise stated on this site without regard to the date on which you may access the information.
            </p>
            <p className="text-sm leading-relaxed text-slate-600 font-body">
              This material is provided by IGAM and is intended for use only by a market counterparty or accredited investor and is not intended for, nor should be relied upon by retail clients.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfUsePage;
